import { publicAxios } from "@/common/api/axios"
import { LoginValidationSchema } from "@/features/auth/schemas/login.schema";
import axios from "axios";

export const login = async (form: LoginValidationSchema) => {
  try {
    const { data, headers } = await publicAxios.post('/auth/login', {
      admin_user: {
        email: form.email,
        password: form.password
      }
    });
    return {
      infos: data,
      accessToken: headers?.authorization,
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error?.response?.data?.errors?.base?.[0] || 'Erro ao fazer login.');
    } else {
      throw new Error('Ocorreu um erro inesperado ao fazer login.');
    }
  }
}
